import { CSSObject } from '@mantine/core';
import { textVariants } from '@ui/tokens/typography/typography';
import { MantineThemeComponent } from '../../types';

const SelectDefaultConfig: MantineThemeComponent = {
	defaultProps: {
		drop: 'bottom-start'
	},
	styles: {
		input: {
			...( textVariants.body as CSSObject ),
			'color': 'var(--color-text-primary)',
			'border': '1px solid var(--color-outline-default)',
			'backgroundColor': 'var(--color-bg-surface)',
			'borderRadius': '4px',
			'padding': '4px 8px',
			'height': '44px',
			'&::placeholder': {
				...( textVariants.body as CSSObject )
			}
		},
		label: {
			...( textVariants[ 'body-bold' ] as CSSObject ),
			color: 'var(--color-text-primary)',
			marginBottom: 8
		},
		item: {
			...( textVariants.body as CSSObject ),
			'color': 'var(--color-text-primary)',
			'&:hover': { backgroundColor: 'var(--color-bg-container-hover)' }
		},
		dropdown: {
			'border': '1px solid var(--color-outline-default)',
			'backgroundColor': 'var(--color-bg-container)',
			'marginTop': -4,
			'borderRadius': '4px'
		}
	}
};

export default SelectDefaultConfig;
